import React from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Avatar, Col, Row } from 'antd';
import Checkbox from 'components/Checkbox';
import { IStaffItemData } from 'services/shop/types/staff';
import styled from 'styled-components';

type Props = {
  staffs: IStaffItemData[];
  selectedIds: string[];
  onToggle: (id: string) => void;
};

const StaffPickerGrid = ({ staffs, selectedIds, onToggle }: Props) => {
  if (!staffs.length) return <EmptyText>No staff found</EmptyText>;

  return (
    <Row gutter={[12, 12]}>
      {staffs.map((o) => {
        const isSelected = selectedIds.includes(o.id);
        return (
          <Col
            key={o.id}
            span={3}
            onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
              // Chặn nổi bọt để popover không đóng khi đang tick nhiều staff.
              e.stopPropagation();
              onToggle(o.id);
            }}
          >
            <LabelStaffItem className={isSelected ? 'selected' : ''}>
              <CheckboxSlot>
                <Checkbox style={{ zoom: 2 }} value={isSelected} size='small' />
              </CheckboxSlot>
              <Avatar
                src={o.urlImage || undefined}
                size={87}
                icon={<UserOutlined />}
                shape='circle'
              />
              <div className='title'>{o.firstName}</div>
            </LabelStaffItem>
          </Col>
        );
      })}
    </Row>
  );
};

export default StaffPickerGrid;

const EmptyText = styled.div`
  padding: 24px;
  text-align: center;
  color: #86909c;
  font-size: 18px;
`;

const CheckboxSlot = styled.div`
  position: absolute;
  top: 6px;
  right: 0px;
  pointer-events: none;
`;

const LabelStaffItem = styled.div`
  position: relative;
  cursor: pointer;
  display: flex;
  padding: 8px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  border: 2px solid #e9edf2;
  background: #f6f7fc;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

  &.selected {
    border-color: #ff7d00;
    box-shadow: 0 0 0 1px rgba(255, 125, 0, 0.15);
  }

  .title {
    color: #1d2129;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    line-height: 30px;
    text-transform: uppercase;
  }
`;
